import { compararMontos } from "../utils/CompararMontos";
import { toNumber } from "../utils/ToNumber";
import { validarIIBB } from "./iibb.validator";
import { validarInstrumentos } from "./instrumentos.validator";
import { validarRecibos } from "./recibos.validator";
import { validarRetenciones } from "./retenciones.validator";
import { validarTarjetas } from "./tarjetas.validator";
import { calcularTotalRecibo } from "../utils/CalcularTotalRecibo";

export function validarReceipt(receipt) {
  const errors = [];

  const efectivo = parseFloat(receipt.recibo.efectivo);
  if (receipt.recibo.efectivo && (isNaN(efectivo) || efectivo < 0)) {
    errors.push("El importe en efectivo no puede ser negativo");
  }

  // Validar que haya al menos un método de pago
  const tieneEfectivo = efectivo > 0;
  const tieneInstrumentos = receipt.instrumentos.some(
    (i) => parseFloat(i.importe) > 0,
  );
  const tieneTarjetas = receipt.tarjetas.some((t) => parseFloat(t.importe) > 0);

  if (!tieneEfectivo && !tieneInstrumentos && !tieneTarjetas) {
    errors.push("Debe ingresar al menos un método de pago");
  }

  const tarjetasResult = validarTarjetas(receipt.tarjetas);
  const instrumentosResult = validarInstrumentos(receipt.instrumentos);
  const iibbResult = validarIIBB(receipt.retenciones?.retencionesIIBB ?? []);
  const retencionesResult = validarRetenciones(receipt.retenciones);
  const recibosResult = validarRecibos(receipt.recibo);

  if (!tarjetasResult.isValid) errors.push(...tarjetasResult.errors);
  if (!instrumentosResult.isValid) errors.push(...instrumentosResult.errors);
  if (!iibbResult.isValid) errors.push(...iibbResult.errors);
  if (!retencionesResult.isValid) errors.push(...retencionesResult.errors);
  if (!recibosResult.isValid) errors.push(...recibosResult.errors);

  const totalRecibo = calcularTotalRecibo(receipt);
  const TOTAL_ESPERADO = toNumber(receipt.recibo.totalEsperado);

  if (!compararMontos(totalRecibo, TOTAL_ESPERADO))
    errors.push("El total esperado con el total calculado no coinciden!");

  return {
    isValid: errors.length === 0,
    errors,
  };
}
